<template>
  <div class="main">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>装备</el-breadcrumb-item>
        <el-breadcrumb-item>Price Ladder分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
      <el-button @click="goto" type="primary">Price Ladder <svg-icon name="play" size="12" ></svg-icon> </el-button>
    </SearchBar>
    <div v-if="viewResult" style="margin:40px auto;">
      <xy-toolbox-menu>
        <xy-toolbox-menu-item custom>
          <div class="custom-content">
            <el-select v-model="avalue" placeholder="分析类型选择">
              <el-option v-for="item in analysisOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </xy-toolbox-menu-item>
        <xy-toolbox-menu-item divided/>
        <xy-toolbox-menu-item icon="car_search" @click="goback">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
      <div id="chart_context" style="margin-top:40px" v-loading="loading" v-show='avalue=="1"'></div>

      <div style="margin-top:40px; min-height:100px;" v-show='avalue=="2"'>仅支持数据下载。</div>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import SearchBar from '@/components/common/NewSearchBar.vue';
  import {
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex';
  export default {
    name: 'saleanalysis',
    components: {
      SearchBar
    },
    data() {
      return {
        viewResult: false,
        models: [],
        chart: null,
        currentModuleName: 'PriceLadderAnalysis',
        analysisOptions: [{
          value: '1',
          label: 'MSRP骨架蓝图'
        }, {
          value: '2',
          label: 'MSRP价格区间图'
        }],
        avalue: '1',
        loading: true,
      }
    },
    // mounted() {
    //     this. bindChart();
    // },
    computed: {
      ...mapGetters('commonsearch', ['searchCategories', 'hasSelectionResult', 'hasSearchResult', 'showSelectionSubmodel', 'selectionResult', 'searchResult']),
      ...mapGetters('depthanalysis', {
        'priceladderList': 'priceladderList',
        'priceskeletonList': 'priceskeletonList'
      }),
    },
    methods: {
      ...mapActions('depthanalysis', ['queryPriceladderList', 'queryPriceskeletonList']),
      goto() {
        this.viewResult = true;
        var ms = this.selectionResult.filter((item, index) => {
          return this.selectionResult.findIndex((obj) => {
            return obj.modeId === item.modeId;
          }) === index;
        }).map(x => x.model);
        this.models = ms;
        var self = this;
        this.$nextTick(function() {
          self.bindChart();
        });
        this.queryPriceladderList({
          params: {
            models: ms
          },
          handle: this.viewPriceladder
        });
        this.queryPriceskeletonList({
          params: {
            models: this.models
          }
        });
      },
      goback() {

         this.viewResult = false;
         this.loading = true;
      },
      exportExcel() {
 
           
            if(this.avalue=='1'){

              JSONToExcel(this.priceladderList, 'PriceLadder', 'PriceLadder');
            }else{

               JSONToExcel(this.priceskeletonList, 'PriceSkeleton', 'PriceSkeleton');
            }
           

      },
      viewPriceladder() {
        this.loading = false;
        var option = {
          xAxis: {
            data: []
          },
          series: [{
            data: []
          }, {
            data: []
          }]
        };
        for (var item of this.priceladderList) {
          option.xAxis.data.push(item.name);
          option.series[1].data.push({value:(item.max - item.min), max:item.max});
          option.series[0].data.push(item.min);
        }
     
        this.chart.setOption(option);
      },
      bindChart() {
        let this_ = this;
        let myChart = echarts.init(document.getElementById('chart_context'));
        this.chart = myChart;
        var option = {
          title: {
            text: ' ',
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              var tar = params[0];
                  return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value + ' - ' +( parseInt( tar.value) + parseInt(params[1].value));
            }
          },
           toolbox: {
            left: 'right',
            feature: {
               
                saveAsImage: {}
            }
        },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            splitLine: {
              show: false
            },
            data: []
          },
          yAxis:[{
                    boundaryGap: [0, '20%'],
                    axisLine: {
                        lineStyle: {
                            color: '#000000'
                        },
                    },
                    name: 'MSRP',
                    type: 'value',
                    offset: 0,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value}'
                    }
                     
                }],
          series: [{
              name: 'MSRP',
              type: 'bar',
              stack: 'MSRP',
              barWidth: '36%',
              label: {
                normal: {
                  show: true,
                  position: ['40%', 10],
                  color:'rgba(244, 164 ,96,1)'
                },
              },
                itemStyle: {
                normal: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)',
                  width: '50px',
                },
                emphasis: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)',
                  width: '50px',
                }
              },
              data: []
            },
            {
              name: 'MSRP',
              type: 'bar',
              stack: 'MSRP',
          
              yAxisIndex: 0,
              itemStyle: {
                normal: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(244, 164 ,96,1)',
                  width: '50px',
                },
                emphasis: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(244, 164 ,96,1)',
                  width: '50px',
                }
              },
               label: {
                normal: {
                  show: true,
                  position: 'top',
                   
                },
               
              },
              data: []
            }
          ]
        };
        myChart.setOption(option);
        //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
        window.addEventListener('resize', function() {
          myChart.resize()
        });
      },
    },
  }
</script>
<style scoped>
  h2 {
    text-align: center;
    padding: 30px;
    font-size: 18px;
  }
  #chart_context {
    width: 92%;
    height: 600px;
    margin: 0 auto;
  }
</style>